var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_2030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2701 7.90995C21.2501 8.39995 21.2501 9.19999 20.2701 9.69999L18.1201 10.75L12.4401 13.53C12.1501 13.64 11.8101 13.64 11.5201 13.53L5.88011 10.75L3.73012 9.69999C2.75012 9.19999 2.75012 8.39995 3.73012 7.90995L11.5501 4.09001C11.8401 3.98001 12.1801 3.98001 12.4701 4.09001L20.2701 7.90995V7.90995Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 10.75V15.86C18.1001 16.23 17.9801 16.58 17.7901 16.89C17.5901 17.2 17.3201 17.46 17.0001 17.64L12.4501 19.89C12.3001 19.96 12.1501 19.99 11.9901 19.99C11.8301 19.99 11.6801 19.96 11.5301 19.89L6.98013 17.64C6.66013 17.46 6.38012 17.2 6.19012 16.89C5.99012 16.58 5.88011 16.22 5.86011 15.86V10.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.19807df3fe30e020c39d74ac65b236a7.svg";
export { ForwardRef as ReactComponent };